export default {
  label: 'Codigo de acceso',
  buttonLabel: 'Ingresar',
  errorMessage: 'Codigo de acceso invalido',
};
